// Called by :  src/components/lesson/LessonItem.vue
//              src/components/question/AnswerOpen.vue
//              src/components/question/AnswerScq.vue
//              src/components/question/AnswerUpload.vue
//              src/components/question/AnswerMcq.vue
//              src/components/question/Question.vue

<template>
    <button v-if="url" ref="rBtn" id="audio_btn" class="audio_btn btn btn-outline-primary rounded-circle text-center " :class="tone" :name="role" v-on:click.stop="playSound">
      <span ref="rIcn" id="audio_icon" class="oi oi-volume-high audio_icon"></span>
      <audio :src="url" ref="rSnd" id="audio_tag" class="d-none " controls="controls" preload="auto" controlsList="nodownload">
            Your browser does not support the <code>audio</code> element.
      </audio>
    </button>
</template>

<script>
// ui_tip ; v-bind:title="$t('answer.audioBtnTooltip')" 
// https://blog.logrocket.com/vue-refs-accessing-dom-elements/

export default {
  props: {
    url: String,
    role: String,
    tone: String,
  },
  methods: {
    playSound() {
      //* Fonction pour gérer la lecture d'une source sonore
      var oBtn = this.$refs.rBtn;
      var oIcn = this.$refs.rIcn;
      var oSnd = this.$refs.rSnd;
      if (oSnd.paused) {
          oSnd.play();
          oIcn.classList.add('active','oi-media-pause');
          oIcn.classList.remove('oi-volume-high');
          oSnd.addEventListener('pause', function() {
              oIcn.classList.remove('active','oi-media-pause');
              oIcn.classList.add('oi-volume-high');
          });
      } else {
          oSnd.pause();
          oIcn.classList.remove('active','oi-media-pause');
          oIcn.classList.add('oi-volume-high');
      }
     return false;
    },
    stopEvent(ev) {
      ev.preventDefault();
      // ev.stopPropagation();
      ev.stopImmediatePropagation();
      return false;
    }
  },
  mounted: function() {
    var oBtn = this.$refs.rBtn;
    if (oBtn) oBtn.addEventListener("click", this.stopEvent, false);
    // this.playSound();
  },
}
</script>


<style scoped>
.audio_btn {
  width: 35px;
  height: 35px;
  box-shadow: none;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  margin-top: -0.15rem;
  margin-right: 0.5rem;
  padding: 0 !important;
}
.audio_icon {
  font-size: 1.2em;
  display: block;
  margin: 0 auto;
}
.audio_btn {
  transform: scale(120%);
}

/* 
//* Audio dans la liste des leçons 
src/components/lesson/LessonItem.vue 
*/
[name=lessonList] {
  width: 30px !important;
  height: 30px !important;
}
[name=lessonList] > .audio_icon {
  font-size: 1em !important;
}
[name=lessonList] > .audio_icon.active {
  font-size: 1em !important;
}

/* 
//* Audio pour le titre de la page question 
src/components/question/Question.vue
*/
[name=lessonTitle] {
  width: 40px !important;
  height: 40px !important;
}
[name=lessonTitle] > .audio_icon {
  font-size: 1.3em !important;
}
[name=lessonTitle] > .audio_icon.active {
  font-size: 1.3em !important;
}

/* 
//* Audio pour la question de la page question 
src/components/question/Question.vue
*/
[name=questionTitle] {
  width: 40px !important;
  height: 40px !important;
  box-shadow: 1px 1px #333 !important;
}
[name=questionTitle] > .audio_icon {
  font-size: 1.3em !important;
  text-shadow: 1px 1px #333 !important;
}
[name=questionTitle]:hover > .audio_icon,
[name=questionTitle]:focus > .audio_icon {
  text-shadow: none !important;
}
[name=questionTitle] > .audio_icon.active {
  font-size: 1.3em !important;
}

/* 
//* Audio pour le texte de la page question
src/components/question/Question.vue
*/ 
[name=questionMessage] {
  width: 40px !important;
  height: 40px !important;
  margin-bottom: 0.5rem !important;
  margin-top: 0.5rem !important;
}
[name=questionMessage] > .audio_icon {
  font-size: 1.3em !important;
}
[name=questionMessage] > .audio_icon.active {
  font-size: 1.3em !important;
}

/* 
//* Audio pour la question des pages réponse 
src/components/question/AnswerMcq.vue
src/components/question/AnswerOpen.vue
src/components/question/AnswerScq.vue
src/components/question/AnswerUpload.vue
*/
[name=answerQuestion] {
  width: 40px !important;
  height: 40px !important;
  box-shadow: 1px 1px #333 !important;
}
[name=answerQuestion] > .audio_icon {
  font-size: 1.3em !important;
  text-shadow: 1px 1px #333 !important;
}
[name=answerQuestion]:hover > .audio_icon,
[name=answerQuestion]:focus > .audio_icon {
  text-shadow: none !important;
}
[name=answerQuestion] > .audio_icon.active {
  font-size: 1.3em !important;
}

/* 
//* Audio pour les propositions des pages réponse 
src/components/question/AnswerMcq.vue
src/components/question/AnswerScq.vue
*/
[name=answerProposal] {
  width: 35px !important;
  height: 35px !important;
}
[name=answerProposal] > .audio_icon {
  font-size: 1.2em !important;
}
[name=answerProposal] > .audio_icon.active {
  font-size: 1.2em !important;
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) { 

  /* Audio dans la liste des leçons */
  [name=lessonList] {
    width: 25px !important;
    height: 25px !important;
  }

  /* Audio pour le titre de la page question */
  [name=lessonTitle] {
    width: 30px !important;
    height: 30px !important;
  }

  /* Audio pour la question de la page question */
  [name=questionTitle] {
    width: 30px !important;
    height: 30px !important;
  }

  /* Audio pour le texte de la page question */
  [name=questionMessage] {
    width: 30px !important;
    height: 30px !important;
    /* margin-bottom: 0.25rem !important; */
  }

  /* Audio pour la question des pages réponse */
  [name=answerQuestion] {
    width: 30px !important;
    height: 30px !important;
  }

  /* Audio pour les propositions des pages réponse */
  [name=answerProposal] {
    width: 30px !important;
    height: 30px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/misc/SoundPlayer.vue